import { useCallback } from 'react';
import ym from 'react-yandex-metrika';

export type GoalParams = {
    [key in string]?: string | number | boolean | string[] | number[] | boolean[] | GoalParams | undefined;
};

export function useMetrika(defaultParams?: GoalParams) {
    const sendGoal = useCallback(
        (goal: string, params?: GoalParams) => {
            ym('reachGoal', goal, { ...defaultParams, ...params });
        },
        [defaultParams]
    );

    return { sendGoal };
}
